import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/shared/v1/target_group.types';
import {useCallback} from 'react';
import {useSessionGender, useUpdateSessionGender} from './sessionGender';

export const useSelectedTargetGroup = (): {
  // targetGroup with fallback to FEMALE if no sessionGender is set
  targetGroup: TargetGroup;
  // targetGroup with no fallback to FEMALE
  initialTargetGroup: TargetGroup | undefined;
  switchTargetGroup: (targetGroup: TargetGroup) => void;
} => {
  const {gender, updateGender} = useSessionGender();

  const switchTargetGroup = useCallback(
    (targetGroup: TargetGroup) => {
      const targetGender = convertTargetGroupToGender(targetGroup);
      if (targetGender) {
        updateGender(targetGender);
      }
    },
    [updateGender],
  );

  return {
    targetGroup: convertGenderToTargetGroup({
      gender,
    }) as TargetGroup,
    initialTargetGroup: convertGenderToTargetGroup({
      gender,
      defaultToFemale: false,
    }),
    switchTargetGroup,
  };
};

export const useUpdateTargetGroup = (targetGroup: TargetGroup | undefined) => {
  const nextGender = convertTargetGroupToGender(targetGroup);
  useUpdateSessionGender(nextGender);
};

export const convertTargetGroupToGender = (
  targetGroup: TargetGroup | undefined,
) => {
  switch (targetGroup) {
    case TargetGroup.FEMALE:
      return 'female';
    case TargetGroup.MALE:
      return 'male';
    case TargetGroup.KIDS:
      return 'kids';
    default:
      return undefined;
  }
};

export const convertGenderToTargetGroup = ({
  gender,
  defaultToFemale = true,
}: {
  gender: string | undefined;
  defaultToFemale?: boolean;
}) => {
  switch (gender) {
    case 'kids':
      return TargetGroup.KIDS;
    case 'male':
      return TargetGroup.MALE;
    case 'female':
      return TargetGroup.FEMALE;
    default:
      return defaultToFemale ? TargetGroup.FEMALE : undefined;
  }
};
